import React from 'react';
import {  Table, Accordion } from 'react-bootstrap'; // <-- Added Table and Accordion

/**
 * Renders the specific report for Lesson Activity (REPORT_KINDS.LESSON)
 */
function LessonActivityReport({ reportData, selectedUsers ,classId}) {
  // The API returns all students in `studentIds`, so we filter them
  // based on the `selectedUsers` prop from the options.
  const studentList =
    selectedUsers && selectedUsers.length > 0
      ? reportData.studentIds.filter((s) => selectedUsers.includes(s._id))
      : reportData.studentIds;

  return (
    <Accordion defaultActiveKey="0">
      
      {studentList.map((student, index) => {
        // Get the activity data (array of <tr> strings) for this student
        const studentActivity = reportData.allRecordsActivity[student._id];

        return (
          <Accordion.Item eventKey={String(index)} key={student._id}>
            <Accordion.Header>{student.name}
            </Accordion.Header>
            <Accordion.Body>
              {studentActivity && studentActivity.length > 0 ? (
                <Table striped bordered hover responsive size="sm">
                  <thead>
                    <tr>
                      <th>Session</th>
                      <th>Attendance</th>
                      <th>Homework</th>
                      <th>Duration (h:mm)</th>
                    </tr>
                  </thead>
                  {/* The API provides full <tr> strings.
                      We can join them and set as the tbody's inner HTML. */}
                  <tbody
                    dangerouslySetInnerHTML={{ __html: studentActivity.join('') }}
                  />
                </Table>
              ) : (
                <p>
                  No activity records found for this student in the selected
                  lessons.
                </p>
              )}
            </Accordion.Body>
          </Accordion.Item>
        );
      })}
    </Accordion>
  );
}

export default LessonActivityReport;